<template>
  <WdsStack v-if="reviewerName" direction-column :data-test="dataTest">
    <WdsText primary :text="reviewerName" />
    <WdsText v-if="reviewedAt" secondary :text="formatReviewDate(reviewedAt)" />
  </WdsStack>
  <WdsText v-else secondary sm :text="$t('—')" :data-test="dataTest" />
</template>

<script lang="ts" setup>
import { WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { formatReviewDate } from '@/components/GraphqlDataTable/columns/Compliance/verifiedComplianceData'

defineProps<{
  dataTest: string
  reviewerName: string | null
  reviewedAt: string | null
}>()
</script>
